export default __webpack_public_path__ + "static/media/imgWin.9d09263a.png";